export const ContentAcqTabs = [
  {
    value: 1,
    label: "Purchase Orders",
  }
];
export const ContentAcqPoListConfig = {
  headings: [
    {
      headingLabel: "PO #",
      icon: "",
      width: "10%",
      inputType: "text",
    },
    {
      headingLabel: "Date",
      icon: "",
      width: "10%",
      inputType: "text",
    },
    {
      headingLabel: "Vendor",
      icon: "",
      width: "25%",
      inputType: "text",
    },
    {
      headingLabel: "Purchase Subtotal",
      icon: "",
      width: "13%",
      inputType: "text",
    },
    {
      headingLabel: "Rush",
      icon: "",
      width: "12%",
      inputType: "text",
    },
    {
      headingLabel: "Modified By",
      icon: "",
      width: "25%",
      inputType: "text",
    },
  ],
  dataNodes: [
    "po_number",
    "created_at",
    "vendor_name",
    "total_cost_value",
    "rush",
    "modified_by_name",
  ],
  primaryKey: "po_id",
  hyperlinks: ["po_number"],
  actions: ["file"],
  showLoader: false
};